import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { accountTypeMap } from '../../../shared/models/Enum/AccountTypeMap';

@Component({
  selector: 'ns-paper-account',
  template: require('./paper-account.component.html')
})

export class PaperAccountComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);

    const accountType = this.flowManager.getAccountType();
    const accountArray = accountTypeMap[accountType];
    const investDocsRoot = this.flowManager.config.investDocsRoot;
    try {
      this.account = accountArray[0];
      this.accountURL = `${investDocsRoot}${accountArray[1]}`;
    } catch (e) {
      console.log('accountMap:', e);
    }

    this.accountType = {
      stepTitle: 'Download Documentation'
    };
  }
}
